





























import { defineComponent, PropType, computed } from '@vue/composition-api'
import { formatDate } from '@/utils/date-helper'
import { useRequest, RequestFunc } from '@shared/use/use-request'
import { UserInfoState } from '@/layout/types'
import { HOSTS } from '@/constants/environment'
import { isEmpty } from 'lodash'

import { saveUserSetting, fetchLastLoginInfo } from '@/api/user'
import { Release, Notice, Security, Profile, Language, Help } from '@/components/mkt-header'
import { Button } from 'amumu-ui'

interface LastLoginInfo {
  province: string
  country: string
  login_time: string
}

const useLastLoginInfo = () => {
  const { data } = useRequest<LastLoginInfo>(fetchLastLoginInfo as RequestFunc, {
    initialData: {},
  })

  const lastLoginAddress = computed(() => {
    return `${data.value.country} ${data.value.province}`
  })

  const isEmptyLoginInfo = computed(() => {
    return isEmpty(data.value)
  })

  return {
    lastLoginInfo: data,
    lastLoginAddress,
    isEmptyLoginInfo,
  }
}

const handleSwitchLanguage = (language: string) => {
  saveUserSetting({
    key: 'USER_LANGUAGE',
    value: language,
  }).then(() => {
    window.location.reload()
  })
}

export default defineComponent({
  components: {
    Profile,
    Language,
    Notice,
    Security,
    Release,
    Help,
    'ui-button': Button,
  },
  props: {
    userInfoState: {
      required: true,
      type: Object as PropType<UserInfoState>,
    },
  },
  setup(props) {
    const { lastLoginInfo, lastLoginAddress, isEmptyLoginInfo } = useLastLoginInfo()

    const userBaseInfoState = computed(() => {
      const { avatar, family_name, second_name, nickname, email } = props.userInfoState
      return {
        avatar: avatar || require('../../assets/images/avatar.png'),
        real_name: family_name + second_name,
        nickname,
        email,
      }
    })

    const url = {
      shop: HOSTS.MALL,
      security: HOSTS.SECURITY,
      history: `${HOSTS.CRM_HOST}/security/loginLogs`,
      guide: `${HOSTS.CRM}/onboarding`,
    }

    return {
      url,
      userBaseInfoState,
      lastLoginInfo,
      lastLoginAddress,
      handleSwitchLanguage,
      isEmptyLoginInfo,
    }
  },
  filters: {
    dateFormat(value = new Date()) {
      return formatDate(value, 'MM-dd HH:mm')
    },
  },
})
